<!-- Code -->
<span *ngIf="display === 'page' else code" class="breadcrumbs">
  {{ getModuleName() }} / {{ getSubmoduleName() }} / {{ element.code }}
</span>

<!-- Code -->
<ng-template #code>
  <span class="code a"
    [matTooltip]="'specificationdetailpagegoto' | translate"
    matTooltipPosition="right"
    (click)="goToElement('detail')">
    {{ element.code }}
  </span>
</ng-template>

<!-- Element location -->
<span class="location">
  <span class="divider">//</span>
  <span class="a" [ngSwitch]="element.projectLevel">

    <!-- Project -->
    <span *ngSwitchCase="1"
      [matTooltip]="'pvesectiongoto' | translate"
      matTooltipPosition="right"
      (click)="goToElement('pve')">
      {{ 'pvesection' | translate }}
    </span>

    <!-- Bulding -->
    <span *ngSwitchCase="2"
      [matTooltip]="'pvesectiongoto' | translate"
      matTooltipPosition="right"
      (click)="goToElement('pve')">
      {{ 'pvesection' | translate }}
    </span>

    <!-- Basic Area -->
    <span *ngSwitchCase="4"
      [matTooltip]="'specificationareatypegoto' | translate"
      matTooltipPosition="right"
      (click)="goToElement('basicArea')">
      {{ 'specificationtypeareagoto' | translate }}
    </span>

    <!-- Area -->
    <span *ngSwitchCase="5"
      [matTooltip]="'specificationtypeareagoto' | translate"
      matTooltipPosition="right"
      (click)="goToElement('area')">
      {{ 'specificationtypearea' | translate }}
    </span>

  </span>
</span>
